import { t } from "i18next";

import { Typography } from "@mui/material";

import FAQSingleAccordion from "@/src/components/atoms/FAQSingleAccordion/FAQSingleAccordion";
import { FAQJson } from "@/src/components/molecules/FAQList/FAQList";

import type { CaravanType } from "@/src/utils/caravanTypes";

interface FAQContainerProps {
  stepId?: number;
  showIds?: number[];
  caravanType?: CaravanType;
}

const shouldShowFaqForCaravan = (
  faq: { hideForCaravanTypes?: CaravanType[] },
  caravanType?: CaravanType
): boolean => {
  if (!caravanType || !faq.hideForCaravanTypes?.length) return true;
  return !faq.hideForCaravanTypes.includes(caravanType);
};

export const FAQContainer = (props: FAQContainerProps) => {
  const { stepId, showIds, caravanType } = props;
  const selectedFAQJson = FAQJson;
  let content;

  // If auction wizard's steps are present, show them
  if (stepId !== undefined) {
    content = (
      <div>
        {selectedFAQJson.data
          .filter((singleFAQ) => singleFAQ.stepIds.includes(stepId))
          .filter((singleFAQ) =>
            shouldShowFaqForCaravan(singleFAQ, caravanType)
          )
          .map((singleFAQ, index) => (
            <FAQSingleAccordion key={index} item={singleFAQ} />
          ))}
      </div>
    );
  }

  // If assigned FAQ section ids, show them at a higher priority
  if (showIds !== undefined) {
    content = (
      <div>
        {selectedFAQJson.data
          .filter((singleFAQ) => showIds.find((id) => id === singleFAQ.id))
          .map((singleFAQ, index) => (
            <FAQSingleAccordion key={index} item={singleFAQ} />
          ))}
      </div>
    );
  }

  return (
    <>
      <Typography variant="h2">{t("faq.faq-title")}</Typography>
      {content}
    </>
  );
};
